import React, {useState} from 'react';
import {ReactComponent as GiftIco} from "../../../images/icons/gift.svg";
import {RootState} from "../../../reducers";
import {getStoreState} from "../../services/Store/reducer";
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import DrawerVouchers from "./DrawerVouchers/DrawerVouchers";

interface OwnProps {
    hideCouponBox?: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const NavbarVouchers = ({ config, hideCouponBox }: Props) => {
    const [openVouchersDrawer, setOpenVouchersDrawer] = useState(false);
    const {t} = useTranslation();

    if(!config.default_config?.loyalty?.points?.enabled) return <></>;

    const handleOpenVouchersDrawer = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setOpenVouchersDrawer(true);
        event.currentTarget.blur();
    }

	return (
		<>
            <button className={"btn btn-icon"} onClick={handleOpenVouchersDrawer} aria-label={t("modules.navbar.field.vouchers.title")}>
                <GiftIco aria-hidden="true" />
            </button>
            <DrawerVouchers show={openVouchersDrawer} onHide={() => setOpenVouchersDrawer(false)} hideCouponBox={hideCouponBox}/>
        </>
	)
}

const mapStateToProps = (state: RootState) => ({
    config: getStoreState(state.config)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(NavbarVouchers));